import { Select as MuiSelect, SelectProps } from '@material-ui/core'

export const Select = (opts: SelectProps) => {
  return (
    <MuiSelect fullWidth={true} {...opts} />
  )
}